<template>
    <div class="col-12" v-if="data.length > 0">
        <div class="single-crossselling__headline">{{ $translate("OD3dprimaV2::Template.crosssellerHeadline") }}</div>
        <div class="row">
            <div class="col-12">
                <div class="single-crossselling">
                    <div v-for="item in data" class="single-crossselling__item"
                        :data-price="getPrice('prices.default.data.basePrice' + appendNet, item.data)" :data-id="item.id">
                        <div class="single-crossselling__indicator single-crossselling__indicator--add"
                            data-container="body" data-html="true" data-trigger="hover" data-toggle="popover"
                            data-placement="top" data-content="Artikel zum Warenkorb hinzufügen">
                            <!-- TODO: translate -->
                        </div>
                        <div class="single-crossselling__indicator single-crossselling__indicator--remove d-none"
                            data-container="body" data-html="true" data-trigger="hover" data-toggle="popover"
                            data-placement="top" data-content="Artikel vom Warenkorb entfernen">
                            <!-- TODO: translate -->
                            <img :src="pluginPath + '/images/icon-check.svg'">
                        </div>
                        <div class="single-crossselling__image">
                            <img class="img-fluid" :src="item.data.images.all[0].urlMiddle"
                                :alt="item.data.texts.name1">
                        </div>
                        <div class="single-crossselling__name">
                            <a :href="item.data | itemURL" :title="item.data.texts.name1">
                                {{ item.data.texts.name1 }}
                            </a>
                        </div>

                        <!-- TOOD: net / brut anhand cookie etc. -->
                        <div class="single-crossselling__price">+ {{ getPrice('prices.default.data.basePrice' + appendNet,
                            item.data) | currency }}
                            <template
                                v-if="item.data.prices.rrp && item.data.prices.rrp.price && item.data.prices.rrp.price.value > item.data.prices.default.price.value">
                                <span class="single-crossselling__price-uvp"><del>{{
                                    getPrice('prices.rrp.data.basePrice' +appendNet, item.data) | currency
                                        }}</del></span>
                            </template>
                        </div>
                    </div>
                    <template v-if="count > 4">
                        <div class="single-crossselling__show-more">
                            <div class="single-crossselling__indicator"><img
                                    :src="pluginPath + '/images/icon-arrow-down.svg'"></div>
                            <span>{{ $translate("OD3dprimaV2::Template.crosssellerMore") }}</span>
                        </div>
                        <div class="single-crossselling__show-less d-none">
                            <div class="single-crossselling__indicator"><img
                                    :src="pluginPath + '/images/icon-arrow-down.svg'"></div>
                            <span>{{ $translate("OD3dprimaV2::Template.crosssellerLess") }}</span>
                        </div>
                    </template>
                </div>
            </div>
            <div class="col-12">
                <div class="single-crossselling__receiver">
                    <div class="single-crossselling__receiver-images">
                    </div>
                    <div class="single-crossselling__receiver-total">
                        <span>{{ $translate("OD3dprimaV2::Template.crosssellerTotal") }} </span><span
                            class="single-crossselling__receiver-total-price"></span>
                        <button class="btn btn-primary single-crossselling__add-to-basket" disabled>{{
                            $translate("OD3dprimaV2::Template.crosssellerAddToBasketButton") }}
                        </button>
                        <input type="hidden" value="false" id="single-crossselling__add-add-items">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import MonetaryFormatter from '~/app/helper/MonetaryFormatter';
import { get } from "ceres/app/helper/get";

export default {
    props: {
        data: {
            type: [Array, Object],
            default: () => []
        },
        itemid: {
            type: Number,
            default: 0
        }
    },

    mounted() {
        // TODO: umbau auf vue native functions - zur zeit übernommen aus main.js da die b2b / b2c funktion integriert werden musste
        if (!!document.querySelector(".single-crossselling")) {
            this.$nextTick(() => {
                let that = this;
                window.setTimeout(function () {

                    let items = document.querySelectorAll(".single-crossselling__item");
                    const formatter = new MonetaryFormatter();

                    document.querySelector(".single-crossselling__receiver-total-price").innerHTML = formatter.format(parseFloat(that.getPrice('prices.default.data.basePrice' + that.appendNet, that.currentVariation)), App.activeCurrency);

                    let indicatorsAdd = document.querySelectorAll(".single-crossselling__indicator--add");

                    for (let key in indicatorsAdd) {
                        if (indicatorsAdd.hasOwnProperty(key)) {
                            indicatorsAdd[key].addEventListener("click", function (event) {
                                event.stopPropagation();
                                this.classList.add("d-none");
                                this.closest(".single-crossselling__item").querySelector(".single-crossselling__indicator--remove").classList.remove("d-none");
                                this.closest(".single-crossselling__item").classList.add("is-selected");

                                let activeItems = document.querySelectorAll(".single-crossselling__item.is-selected");
                                let mainPrice = that.getPrice('prices.default.data.basePrice' + that.appendNet, that.currentVariation);
                                let addedPrices = 0;
                                let addedImages = "";

                                for (let key in activeItems) {
                                    if (activeItems.hasOwnProperty(key)) {
                                        addedPrices += parseFloat(activeItems[key].dataset.price);
                                        addedImages += "<img src='" + activeItems[key].closest(".single-crossselling__item").querySelector(".single-crossselling__image img").src + "'>";
                                    }
                                }

                                let total = mainPrice + addedPrices;
                                total = formatter.format(parseFloat(total), App.activeCurrency);

                                document.querySelector(".single-crossselling__receiver-total-price").innerHTML = total;
                                document.querySelector(".single-crossselling__receiver-images").innerHTML = addedImages;
                                document.querySelector(".single-crossselling__add-to-basket").removeAttribute("disabled");

                            });

                            indicatorsAdd[key].click();
                        }
                    }

                    let indicatorsRemove = document.querySelectorAll(".single-crossselling__indicator--remove");

                    for (let key in indicatorsRemove) {
                        if (indicatorsRemove.hasOwnProperty(key)) {
                            indicatorsRemove[key].addEventListener("click", function (event) {
                                event.stopPropagation();
                                this.classList.add("d-none");
                                this.closest(".single-crossselling__item").querySelector(".single-crossselling__indicator--add").classList.remove("d-none");
                                this.closest(".single-crossselling__item").classList.remove("is-selected");

                                let activeItems = document.querySelectorAll(".single-crossselling__item.is-selected");
                                let mainPrice = that.getPrice('prices.default.data.basePrice' + that.appendNet, that.currentVariation);
                                let addedPrices = 0;
                                let addedImages = "";
                                const formatter = new MonetaryFormatter();

                                if (activeItems.length > 0) {
                                    for (let key in activeItems) {
                                        if (activeItems.hasOwnProperty(key)) {
                                            addedPrices += parseFloat(activeItems[key].dataset.price);
                                            addedImages += "<img src='" + activeItems[key].closest(".single-crossselling__item").querySelector(".single-crossselling__image img").src + "'>";
                                        }
                                    }

                                    let total = mainPrice + addedPrices;
                                    total = formatter.format(parseFloat(total), App.activeCurrency);

                                    document.querySelector(".single-crossselling__receiver-total-price").innerHTML = total;
                                    document.querySelector(".single-crossselling__receiver-images").innerHTML = addedImages;
                                } else {
                                    document.querySelector(".single-crossselling__receiver-total-price").innerHTML = formatter.format(parseFloat(that.getPrice('prices.default.data.basePrice' + that.appendNet, that.currentVariation)), App.activeCurrency);
                                    document.querySelector(".single-crossselling__receiver-images").innerHTML = "";
                                    document.querySelector(".single-crossselling__add-to-basket").setAttribute("disabled", "true");
                                }

                            });
                        }
                    }

                    let showMore = document.querySelector(".single-crossselling__show-more");

                    if (showMore !== null) {
                        showMore.addEventListener("click", function (event) {
                            event.stopPropagation();

                            for (let innerKey in items) {
                                if (items.hasOwnProperty(innerKey)) {
                                    items[innerKey].classList.add("show-hidden-items");
                                }
                            }

                            this.classList.add("d-none");
                            document.querySelector(".single-crossselling__show-less").classList.remove("d-none");
                        });
                    }

                    let showLess = document.querySelector(".single-crossselling__show-less");

                    if (showLess !== null) {
                        showLess.addEventListener("click", function (event) {
                            event.stopPropagation();

                            for (let innerKey in items) {
                                if (items.hasOwnProperty(innerKey)) {
                                    items[innerKey].classList.remove("show-hidden-items");
                                }
                            }

                            this.classList.add("d-none");
                            document.querySelector(".single-crossselling__show-more").classList.remove("d-none");
                        });
                    }

                    let addToBasketBtn = document.querySelector(".single-crossselling__add-to-basket");

                    addToBasketBtn.addEventListener("click", function (event) {
                        document.getElementById("single-crossselling__add-add-items").value = true;
                        document.querySelector(".add-to-basket__btn").dispatchEvent(new Event("click"));
                    });
                }, 10);
            });
        }
    },

    methods: {
        getPrice(pricePath, item) {

            //dotted path
            if (pricePath.indexOf('.') > -1) {
                return pricePath.split('.').reduce((o, i) => o[i], item);
            }

            return pricePath;
        }
    },

    computed: {
        count() {
            return this.data.length;
        },

        pluginPath() {
            return App.pluginPath3DPrima;
        },

        appendNet() {
            if (this.currentPriceType === 'b2b') {
                return 'Net';
            }

            return '';
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemid}].variation.documents[0].data`);
        },

        ...mapState({
            currentPriceType: state => state.localization.currentPriceType
        })
    }
}
</script>
